import React, {
    useState,
    useRef,
    useEffect,
    useMemo,
    useCallback,
  } from "react";
  import "bootstrap/dist/css/bootstrap.css";
  import ContactLoader from "views/ContantLoader";
  import { Container } from "reactstrap";
  import "bootstrap/dist/css/bootstrap.css";
  import Tooltip from "react-bootstrap/Tooltip";
  import OverlayTrigger from "react-bootstrap/OverlayTrigger";
  import { useSelector, useDispatch } from "react-redux";
  import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
  import { getPermissions } from 'api/UsersApi'
  import SupportLink from "../Common/SupportLink";
  import {exportUsers} from 'api/ExportApi'
  
  import { getAllUsers, putUser, getUserscount } from "api/UsersApi";
  import Table from "../Table";
  import {GET , POST , PUT} from '../../api/API'
 import ContantLoader from "views/ContantLoader";
  var offSet = 0;
  var matchNextButton = 1;
  
  const AllUsers = (props) => {
    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [createUserPermission, setCreateUserPermission] = useState(false);
    const [permissionMessage, setPermissionMessage] = useState(null);
    const [showPermissionMessage, setShowPermissionMessage] = useState(true);
    const [currentTab, setCurrentTab] = useState("transaction");
    const [month, setMonth] = useState([]);
    const [year, setYear] = useState([]);
    const [downLink, setDownLink] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);

    const searchText = useRef("");
  
    const { companyUserLoading } = useSelector(
      (state) => state.companyUserSetter
    );
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setCompanyUserLoading(true));
      getPermissions().then(res => {
        // 
        setCreateUserPermission(!res['CreateUser'].allowed);
        setPermissionMessage(res['CreateUser'].message);
      })
    }, []);

    useEffect(()=>{
      // console.log("YEAR", year);
      // console.log("MONTH", month);
      const data = month.map((m, index) => ({
        date: `${monthNames[m-1]} ${year[index]}`,
        link: downLink[index]
      }))
      console.log("data is here ", data);
      setInvoiceData(data);
    },[year, month, downLink])

    useEffect(() => {
      GET("company/invoices")
      .then((data) => {
        // Object.keys(data).forEach(attr => {
        //   console.log("ATTR => ", attr);
        // })
        console.log("Invoices data => ", data);
        if (data && data.length > 0) {
          const months = data.map(item => item.month);
          const years = data.map(item => item.year);
          const link = data.map(item => item.stripeInvoiceDownloadUrl);

          setMonth(months);
          setYear(years);
          setDownLink(link);
        }

      })
      .catch(err => {
        console.log("ERROR => ", err);
      })
    },[])
  
    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        //dispatch(setCompanyUserLoading(true));
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPageIndex(pageIndex);
        await GET(`company/payments/count`)
            .then((data) => {
                setPageCount(Math.ceil(data.count / pageSize));
                setTotal(data.count);
            })
            .catch((e) => { })

          let url = dataApi.length ? `company/payments?limit=${pageSize}&offset=${dataApi[dataApi.length-1]?.id}` : `company/payments?limit=${pageSize}`
        await GET(url )
            .then((data) => {
                data.forEach((r) => {
                    r.created = new Date(r.created * 1000).toLocaleDateString()
                    r.amount = `$ ${Number(r.amount/100).toFixed(2)}`

                })
                console.log(data)
                //
                setDataApi(data);
                dispatch(setCompanyUserLoading(false));

            })
            .catch((e) => { })
    }, []);

    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => [

            {
                Header: "Description",
                accessor: "description",

            },
            {
                Header: "Customer",
                accessor: "customer",

            },
            {
                Header: "Amount",
                accessor: "amount",

            },
            {
                Header: "Date",
                accessor: "created",

            },

   
        ],
        [dataApi]
    );

    const columns1 = [
      {
        Header: 'Date',
        accessor: 'date',
      },
    ];

    const activate = (id, is) => {
  
      var status;
      if (is) status = "active";
      else status = "inactive";
      var data = {
        status: status,
      };
      putUser(id, data)
        .then((res_data) => {
          // getAllUsers(offSet)
          //   .then((data) => {
          let temp = [...dataApi];
          var x = temp.find((u) => {
            return u.id == id;
          });
          x.status = status;
          setDataApi(temp);
          // })
          // .catch((e) => 
        })
        .catch((e) => { })
    };
    const createUser = () => {
      props.history.push(`/admin/users/create`);
    };
  
    const messageBar = (permissionMessage) => {
      if (permissionMessage) {
        return (
          showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
            <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>
  
            <span onClick={() => {
              setShowPermissionMessage(false)
            }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
          </div>
        )
      }
    }

    const TRANSACTION_TAB = {
        name: 'Transactions',
        id: 'transaction',
        status: 'active',
        //icon: 'fas fa-envelope',
        tab: 'transaction',
    };
    const Invoice_TAB = {
        name: 'Invoices',
        id: 'Invoice',
        status: '',
        //  icon: 'fas fa-globe',
        tab: 'Invoice',
    };
    const TABS = [ TRANSACTION_TAB, Invoice_TAB

    ];
    const tabChanged = (tab) => {
        TABS.map(t => {
            if (t.id === tab.id)
                t.status = 'active'
            else
                t.status = ''
        })



        setCurrentTab(tab.id)
    };
    const NavTab = (tab) => {
        let currentStatus = '';
        if (currentTab === tab.tabinfo.id) {
            currentStatus = 'active';
        } else {
            currentStatus = '';
        }
        return (
            <li className='nav-item'>
                <a
                    onClick={() => {
                        tab.tabChanged(tab.tabinfo);
                    }}
                    className={`nav-link ${currentStatus}`}
                    href={'#' + tab.tabinfo.id}
                    role='tab'
                    data-toggle='tab'
                    key={tab.key_id}
                >
                    <i className={tab.tabinfo.icon}></i> {tab.tabinfo.name}
                </a>
            </li>
        );
    };

    const monthNames = [
      "January", "February", "March", "April", "May", "June", 
      "July", "August", "September", "October", "November", "December"
    ];

    const Link = "https://pay.stripe.com/invoice/acct_1LNskRGrSqg1SI86/test_YWNjdF8xTE5za1JHclNxZzFTSTg2LF9RWFZ1Z2xsU3ZtTG1FREpVNGw4NkEwRlNzc04zYVZJLDExMjQ1MTY5OQ02009kGasG2Z/pdf?s=ap"

  
    return (
      <Container>
        {messageBar(permissionMessage)}
        <SupportLink link='https://kapitalwise.com/user-guide/settings#user_setup' />
  
        <div className="page_heading" style={{ display: "flex" }}>
          <div style={{ flex: "1" }}>
            <h2>Charge and Fees</h2>
  
            {/* <p className="sm d-flex align-items-center">
              You have {total} Payments.
            </p> */}
          </div>

        </div>
        <div></div>

        <div className='cmpgn_list_outer'>
            <div className='cmpgn_tab_erap'>
                <ul className='nav nav-tabs' role='tablist'>
                    {TABS.map((tab, index) => {
                        return (
                            <NavTab
                                key={index}
                                key_id={tab.id}
                                tabChanged={tabChanged}
                                tabinfo={tab}
                            />
                        );
                    })}
                </ul>
            </div>

        </div>

        {
          currentTab == 'transaction' ? 
          
          <div>

            {dataApi ? (
              <div className="dataTableOuter">

                <div className="table-flter rdt_Pagination d-flex align-items-center">
                  <span className="inline-label ml-auto">
                    Page No. {pageIndex + 1} of {pageCount}
                  </span>
                </div>
                {
                  <Table
                  columns={columns}
                  data={data}
                  pageCount={pageCount}
                  fetchData={fetchData}
                  loading={companyUserLoading}
                  ></Table>
                }
              </div>
            ) : (
              <ContactLoader />
            )}
          </div>

        : 
        <div>
          {
            <Table
            columns={columns1}
            data={invoiceData}
            pageCount={pageCount}
            fetchData={fetchData}
            loading={companyUserLoading}
            onRowClick={(e, row) => {
              if (row.link) {
                window.location.href = row.link;
              } 
            }}
            downLink={true}
            ></Table>
          }
        </div>
        }
      </Container>
    );
  };
  
  export default AllUsers;
  